'use client';

import { Link } from '@/components/ui/Link';
import { PlayCircleIcon } from '@heroicons/react/24/solid';

type Props = {
  playlistId: string;
};

export const PlaylistButton = ({ playlistId }: Props) => {
  return (
    <Link href={`/playlist/${playlistId}`} className="w-11">
      <PlayCircleIcon className="h-11 w-11" />
    </Link>
  );
};
